import React from 'react';
import { TrendingDown } from 'lucide-react';

const DrawdownWidget = ({ metrics }) => {
  if (!metrics) return null;

  const {
    max_drawdown,
    max_drawdown_percent,
    current_drawdown,
    current_drawdown_percent,
  } = metrics;

  const meterPercent = max_drawdown_percent > 0
    ? Math.min(100, (current_drawdown_percent / max_drawdown_percent) * 100)
    : 0;

  const isWarning = meterPercent > 50;
  const inDrawdown = current_drawdown > 0;

  return (
    <div className="bg-card text-card-foreground rounded-lg shadow-sm border border-border p-4 md:p-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="p-1.5 rounded-lg bg-red-500/10">
          <TrendingDown className="w-4 h-4 text-red-500" />
        </div>
        <h3 className="text-sm font-semibold text-foreground">Drawdown</h3>
      </div>

      <div className="space-y-3">
        {/* Max Drawdown */}
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Max Drawdown</span>
          <div className="flex items-center gap-1.5">
            <span className="font-medium text-red-500 font-mono tabular-nums">
              -${max_drawdown.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
            <span className="text-red-500/70 font-mono tabular-nums">
              ({max_drawdown_percent.toFixed(2)}%)
            </span>
          </div>
        </div>

        {/* Current Drawdown */}
        <div className="flex items-center justify-between text-xs">
          <span className="text-muted-foreground">Current Drawdown</span>
          {inDrawdown ? (
            <div className="flex items-center gap-1.5">
              <span className={`font-medium font-mono tabular-nums ${isWarning ? 'text-yellow-500' : 'text-red-500'}`}>
                -${current_drawdown.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
              <span className={`font-mono tabular-nums ${isWarning ? 'text-yellow-500/70' : 'text-red-500/70'}`}>
                ({current_drawdown_percent.toFixed(2)}%)
              </span>
            </div>
          ) : (
            <span className="font-medium text-green-500 text-xs">At Peak</span>
          )}
        </div>

        {/* Drawdown Meter */}
        <div className="space-y-1">
          <div className="w-full h-2 bg-secondary rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full transition-all duration-500 ${
                isWarning ? 'bg-yellow-500' : 'bg-red-500'
              }`}
              style={{ width: `${inDrawdown ? Math.max(meterPercent, 4) : 0}%` }}
            />
          </div>
          <div className="flex justify-between text-[10px] text-muted-foreground">
            <span>0%</span>
            <span>Max ({max_drawdown_percent.toFixed(1)}%)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrawdownWidget;
